










































































import {
  Vue,
  Component,
  Watch, Prop
} from "@/shared/vuepack";
import moment from "moment-timezone";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import OtherContributionForm from "@/employee/components/contributionsV2/OtherContributionForm.vue";
import Button from "@/shared/components/ui/Button.vue";
import _ from "lodash";
import { useContributionStore } from "@/shared/store/contribution";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useHsaStore } from "@/shared/store/hsa";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";


@Component({
  components: {
    GenericLoadingSpinner,
    Button,
    ContributionsGraphWidget,
    OtherContributionForm
  }
})

export default class ManageOtherHsaAmount extends Vue {
  contributionStore = useContributionStore();
  hsaTotalStore = useHsaTotalStore();
  hsaStore = useHsaStore();
  hsaLimitStore = useHsaLimitStore();
  personalContributionScheduleStore = usePersonalContributionSchedulesStore();

  isSubmitting = false;
  selectedYear = moment().year();
  otherHsaAmount = 0;

  @Prop()
  routeToContributions: Location;

  mounted () {
    this.contributionStore.getOtherHsaPriorYearCutoffDate();
    this.hsaTotalStore.loadOtherHsaAmounts();
    this.hsaTotalStore.getUserPayrollSummary();
    this.hsaLimitStore.getHsaAccountLimits();
    this.personalContributionScheduleStore.getUpcomingPersonalContributionTotal(this.selectedYear);
    this.hsaStore.loadTransactionTotals({
      year: this.selectedYear
    });
    this.storedOtherHsaAmountChanged();
  }

  get storedOtherHsaAmount () {
      return this.hsaTotalStore.otherHsaAmount(this.selectedYear);
  }

  get isLoaded () {
    return this.contributionStore.otherHsaPriorYearCutoffDateLoaded && this.hsaTotalStore.otherHsaAmountsLoaded;
  }

  get yearsThrough (): number[] {
    return _.range(this.contributionStore.firstPlanEffectiveYear, moment().year() + 1).reverse();
  }

  @Watch("storedOtherHsaAmount")
  storedOtherHsaAmountChanged () {
    this.otherHsaAmount = this.storedOtherHsaAmount;
  }

  get yearOptions (): { text: string, value: string | number }[] {
    return this.yearsThrough
        .map(year => ({
          text: year.toString(),
          value: year
        }));
  }

  get isCurrentYear (): boolean {
    return this.selectedYear === moment().year();
  }

  // personal contribution
  get personalContributionAmount (): number {
    return this.hsaStore.totalEmployeePersonalContributions(this.selectedYear) +
      this.personalContributionScheduleStore.allUpcomingContributions;
  }

  // employee payroll contribution
  get employeePayrollContributions (): number {
    const preTax = this.hsaStore.employeePreTaxContributions(this.selectedYear);
    const postTax = this.hsaStore.employeePostTaxContributions(this.selectedYear);

    return _.floor(preTax + postTax, 2);
  }

  // employer payroll contribution
  get employerPayrollContributions (): number {
    return this.hsaStore.totalEmployerPayrollContributions(this.selectedYear);
  }

  // bank direct contribution
  get bankDirectContribution (): number {
    const result = this.hsaStore.bankDirectContributions(this.selectedYear);

    // adjust for rounding in floating point precision
    return _.floor(result, 2);
  }

  get totalContributionAmount (): number {
    const result = this.personalContributionAmount + this.employeePayrollContributions +
      this.employerPayrollContributions + this.bankDirectContribution + this.otherHsaAmount;

    return _.floor(result, 2);
  }

  get displayLimitWarning (): boolean {
    // Only display warning if we are looking at the current year,
    // and if the user has a projected personal contribution amount they can adjust to fix it/
    return this.isCurrentYear &&
      this.personalContributionScheduleStore.allUpcomingContributions > 0 &&
      this.totalContributionAmount > this.hsaLimitStore.getHsaLimitByYear(this.selectedYear);
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }

    this.$validator.validateAll().then(isValid => {
      if (!isValid) {
        return;
      }
      this.isSubmitting = true;
      this.hsaTotalStore.updateOtherHsa({ amount: this.otherHsaAmount, year: this.selectedYear })
          .finally(() => {
            this.isSubmitting = false;
          });
    });
  }
}
